// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"65d8d17c","258":"166c4d87","471":"14c838ce","603":"afb14b78","604":"a84663c5","665":"6a3a52cf","674":"7b784baa","726":"028fb50d","949":"14cbbcf4"}[chunkId] + ".chunk.css";
};